import Vue from 'vue';
import Buefy from 'buefy';
// import '../styles/_variables.scss';

Vue.use(Buefy);
